import React, { useEffect } from "react";
import "../style/initialPage.css";
import { Link } from "react-router-dom";

const ExerciseCatsPage = (props) => {
  useEffect(() => {
    props.setInit(false);
  }, [props]);
  return (
    <div className="m-initialPage">
      <div className="m-title">Categorías géneros textuales</div>
      <div className="m-selectors">
        <Link
          class="m-selector "
          data-ex="excercie-1-options"
          id="sel-1"
          to="/exercices/"
          target="_self"
        >
          <div class="m-select-text">
            <svg
              class="m-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="#40a14a"
              height="800px"
              width="800px"
              version="1.1"
              id="Layer_1"
              viewBox="0 0 512 512"
            >
              <g>
                <g>
                  <path d="M479.319,68.908V43.574c0-4.513-3.657-8.17-8.17-8.17H288.681c-13.348,0-25.221,6.435-32.681,16.365    c-7.46-9.931-19.333-16.365-32.681-16.365H40.851c-4.513,0-8.17,3.657-8.17,8.17v25.333C14.057,72.703,0,89.208,0,108.936V392.17    c0,22.526,18.325,40.851,40.851,40.851H215.97c3.795,18.624,20.302,32.681,40.03,32.681c19.727,0,36.234-14.057,40.031-32.681    h58.043c4.513,0,8.17-3.657,8.17-8.17s-3.657-8.17-8.17-8.17h-65.393c-4.513,0-8.17,3.657-8.17,8.17    c0,13.515-10.996,24.511-24.511,24.511c-13.515,0-24.511-10.996-24.511-24.511c0-4.513-3.657-8.17-8.17-8.17H40.851    c-13.515,0-24.511-10.996-24.511-24.511V108.936c0-10.651,6.831-19.733,16.34-23.105v273.659c0,4.513,3.657,8.17,8.17,8.17    h182.468c13.515,0,24.511,10.996,24.511,24.511c-6.832-5.12-15.322-8.17-24.511-8.17H40.851c-4.513,0-8.17,3.657-8.17,8.17    s3.657,8.17,8.17,8.17h182.468c13.515,0,24.511,10.996,24.511,24.511c0,4.513,3.657,8.17,8.17,8.17c4.513,0,8.17-3.657,8.17-8.17    c0-13.515,10.996-24.511,24.511-24.511h65.393c4.513,0,8.17-3.657,8.17-8.17s-3.657-8.17-8.17-8.17h-65.393    c-9.189,0-17.678,3.05-24.511,8.191c0-13.535,10.996-24.531,24.511-24.531h89.904v100.766c0,2.738,1.372,5.292,3.653,6.807    c2.278,1.513,5.166,1.784,7.691,0.722l22.684-9.557l22.684,9.557c1.02,0.429,2.098,0.641,3.171,0.641    c1.585,0,3.16-0.461,4.519-1.363c2.281-1.515,3.653-4.07,3.653-6.807v-35.404h24.511c22.526,0,40.851-18.325,40.851-40.851    V108.936C512,89.208,497.943,72.703,479.319,68.908z M247.83,359.51c-6.832-5.141-15.322-8.191-24.511-8.191H49.021V51.745    h174.298c13.515,0,24.511,10.996,24.511,24.511V359.51z M430.298,456.118l-14.514-6.116c-2.029-0.853-4.315-0.853-6.344,0    l-14.514,6.116V367.66h35.372V456.118z M288.681,351.319c-9.189,0-17.678,3.05-24.511,8.191V76.255    c0-13.515,10.996-24.511,24.511-24.511h174.298v299.574H288.681z M495.66,392.17c0,13.515-10.996,24.511-24.511,24.511h-24.511    v-16.34h24.511c4.513,0,8.17-3.657,8.17-8.17s-3.657-8.17-8.17-8.17h-24.511v-16.34h24.511c4.513,0,8.17-3.657,8.17-8.17V85.831    c9.509,3.373,16.34,12.455,16.34,23.105V392.17z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,285.957h-128c-4.513,0-8.17,3.657-8.17,8.17c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    C220.596,289.614,216.939,285.957,212.426,285.957z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,239.66h-128c-4.513,0-8.17,3.657-8.17,8.17c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    C220.596,243.317,216.939,239.66,212.426,239.66z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,193.362h-128c-4.513,0-8.17,3.657-8.17,8.17s3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    S216.939,193.362,212.426,193.362z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,147.064h-128c-4.513,0-8.17,3.657-8.17,8.17s3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    S216.939,147.064,212.426,147.064z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,100.766h-128c-4.513,0-8.17,3.657-8.17,8.17c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    C220.596,104.423,216.939,100.766,212.426,100.766z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M427.574,285.957h-128c-4.513,0-8.17,3.657-8.17,8.17c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    C435.745,289.614,432.088,285.957,427.574,285.957z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M427.574,170.213c4.513,0,8.17-3.657,8.17-8.17v-53.106c0-4.513-3.657-8.17-8.17-8.17h-128c-4.513,0-8.17,3.657-8.17,8.17    V247.83c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17v-53.106c0-4.513-3.657-8.17-8.17-8.17    s-8.17,3.657-8.17,8.17v44.936h-111.66V117.106h111.66v44.936C419.404,166.556,423.061,170.213,427.574,170.213z"></path>
                </g>
              </g>
            </svg>
            <div>Géneros textuales generales</div>
          </div>
          <svg
            class="m-icon"
            viewBox="-5 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Icon-Set"
                  transform="translate(-473.000000, -1195.000000)"
                  fill="#000"
                >
                  <path
                    d="M486.717,1206.22 L474.71,1195.28 C474.316,1194.89 473.678,1194.89 473.283,1195.28 C472.89,1195.67 472.89,1196.31 473.283,1196.7 L484.566,1206.98 L473.283,1217.27 C472.89,1217.66 472.89,1218.29 473.283,1218.69 C473.678,1219.08 474.316,1219.08 474.71,1218.69 L486.717,1207.75 C486.927,1207.54 487.017,1207.26 487.003,1206.98 C487.017,1206.71 486.927,1206.43 486.717,1206.22"
                    id="chevron-right"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </Link>
        <Link
          class="m-selector "
          data-ex="excercie-1-options"
          id="sel-1"
          to="/exercices-turism/"
          target="_self"
        >
          <div class="m-select-text">
            <svg
              class="m-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="#40a14a"
              height="800px"
              width="800px"
              version="1.1"
              id="Layer_1"
              viewBox="0 0 512 512"
            >
              <g>
                <g>
                  <path d="M479.319,68.908V43.574c0-4.513-3.657-8.17-8.17-8.17H288.681c-13.348,0-25.221,6.435-32.681,16.365    c-7.46-9.931-19.333-16.365-32.681-16.365H40.851c-4.513,0-8.17,3.657-8.17,8.17v25.333C14.057,72.703,0,89.208,0,108.936V392.17    c0,22.526,18.325,40.851,40.851,40.851H215.97c3.795,18.624,20.302,32.681,40.03,32.681c19.727,0,36.234-14.057,40.031-32.681    h58.043c4.513,0,8.17-3.657,8.17-8.17s-3.657-8.17-8.17-8.17h-65.393c-4.513,0-8.17,3.657-8.17,8.17    c0,13.515-10.996,24.511-24.511,24.511c-13.515,0-24.511-10.996-24.511-24.511c0-4.513-3.657-8.17-8.17-8.17H40.851    c-13.515,0-24.511-10.996-24.511-24.511V108.936c0-10.651,6.831-19.733,16.34-23.105v273.659c0,4.513,3.657,8.17,8.17,8.17    h182.468c13.515,0,24.511,10.996,24.511,24.511c-6.832-5.12-15.322-8.17-24.511-8.17H40.851c-4.513,0-8.17,3.657-8.17,8.17    s3.657,8.17,8.17,8.17h182.468c13.515,0,24.511,10.996,24.511,24.511c0,4.513,3.657,8.17,8.17,8.17c4.513,0,8.17-3.657,8.17-8.17    c0-13.515,10.996-24.511,24.511-24.511h65.393c4.513,0,8.17-3.657,8.17-8.17s-3.657-8.17-8.17-8.17h-65.393    c-9.189,0-17.678,3.05-24.511,8.191c0-13.535,10.996-24.531,24.511-24.531h89.904v100.766c0,2.738,1.372,5.292,3.653,6.807    c2.278,1.513,5.166,1.784,7.691,0.722l22.684-9.557l22.684,9.557c1.02,0.429,2.098,0.641,3.171,0.641    c1.585,0,3.16-0.461,4.519-1.363c2.281-1.515,3.653-4.07,3.653-6.807v-35.404h24.511c22.526,0,40.851-18.325,40.851-40.851    V108.936C512,89.208,497.943,72.703,479.319,68.908z M247.83,359.51c-6.832-5.141-15.322-8.191-24.511-8.191H49.021V51.745    h174.298c13.515,0,24.511,10.996,24.511,24.511V359.51z M430.298,456.118l-14.514-6.116c-2.029-0.853-4.315-0.853-6.344,0    l-14.514,6.116V367.66h35.372V456.118z M288.681,351.319c-9.189,0-17.678,3.05-24.511,8.191V76.255    c0-13.515,10.996-24.511,24.511-24.511h174.298v299.574H288.681z M495.66,392.17c0,13.515-10.996,24.511-24.511,24.511h-24.511    v-16.34h24.511c4.513,0,8.17-3.657,8.17-8.17s-3.657-8.17-8.17-8.17h-24.511v-16.34h24.511c4.513,0,8.17-3.657,8.17-8.17V85.831    c9.509,3.373,16.34,12.455,16.34,23.105V392.17z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,285.957h-128c-4.513,0-8.17,3.657-8.17,8.17c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    C220.596,289.614,216.939,285.957,212.426,285.957z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,239.66h-128c-4.513,0-8.17,3.657-8.17,8.17c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    C220.596,243.317,216.939,239.66,212.426,239.66z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,193.362h-128c-4.513,0-8.17,3.657-8.17,8.17s3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    S216.939,193.362,212.426,193.362z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,147.064h-128c-4.513,0-8.17,3.657-8.17,8.17s3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    S216.939,147.064,212.426,147.064z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M212.426,100.766h-128c-4.513,0-8.17,3.657-8.17,8.17c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    C220.596,104.423,216.939,100.766,212.426,100.766z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M427.574,285.957h-128c-4.513,0-8.17,3.657-8.17,8.17c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17    C435.745,289.614,432.088,285.957,427.574,285.957z"></path>
                </g>
              </g>
              <g>
                <g>
                  <path d="M427.574,170.213c4.513,0,8.17-3.657,8.17-8.17v-53.106c0-4.513-3.657-8.17-8.17-8.17h-128c-4.513,0-8.17,3.657-8.17,8.17    V247.83c0,4.513,3.657,8.17,8.17,8.17h128c4.513,0,8.17-3.657,8.17-8.17v-53.106c0-4.513-3.657-8.17-8.17-8.17    s-8.17,3.657-8.17,8.17v44.936h-111.66V117.106h111.66v44.936C419.404,166.556,423.061,170.213,427.574,170.213z"></path>
                </g>
              </g>
            </svg>
            <div>Géneros textuales orientados a la industria turística</div>
          </div>
          <svg
            class="m-icon"
            viewBox="-5 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Icon-Set"
                  transform="translate(-473.000000, -1195.000000)"
                  fill="#000"
                >
                  <path
                    d="M486.717,1206.22 L474.71,1195.28 C474.316,1194.89 473.678,1194.89 473.283,1195.28 C472.89,1195.67 472.89,1196.31 473.283,1196.7 L484.566,1206.98 L473.283,1217.27 C472.89,1217.66 472.89,1218.29 473.283,1218.69 C473.678,1219.08 474.316,1219.08 474.71,1218.69 L486.717,1207.75 C486.927,1207.54 487.017,1207.26 487.003,1206.98 C487.017,1206.71 486.927,1206.43 486.717,1206.22"
                    id="chevron-right"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default ExerciseCatsPage;
